export const changeBodyOverflow = value => {
  document.body.style.overflow = value
}
